import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const extractCallMotivationAndObjection = async (callLogId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callLogId,
    },
    query: graphql(`
      query ExtractCallMotivationAndObjection($callLogId: String!) {
        extractCallMotivationAndObjection(callLogId: $callLogId) {
          motivation {
            category
            exampleQuote
          }
          objection {
            category
            exampleQuote
          }
        }
      }
    `),
  });

  return response.data.extractCallMotivationAndObjection;
};
